module.exports = __webpack_public_path__ + "img/transfer-tips.6b0d0801.png";